import paramsList from './params-list';
import { Params } from './types';
import { doBasicCheck, ValidationResult } from '../../validator/shared';
import { getSelectedPartner, SelectedPartner } from '../../categories-config/partner-selector';

export default (params: Params): ValidationResult => {
    if (!doBasicCheck(params, paramsList).isValid) {
        return doBasicCheck(params, paramsList);
    }
    if (
        getSelectedPartner(
            params.gaPageType,
            params.l1Category,
            params.l2Category,
            params.l3Category
        ) !== SelectedPartner.ANYVAN
    ) {
        return {
            isValid: false,
            reason: `Anyvan is not enabled for
            ${params.gaPageType},
            ${params.l1Category},
            ${params.l2Category},
            ${params.l3Category},`,
        };
    }
    return { isValid: true };
};
